module.exports = __webpack_public_path__ + "static/media/dsr_ico_salary.fda73728.svg";